export default __webpack_public_path__ + "static/Freevee_logo-b604c5a05a6570d0ff5d6e7dfd5907dc.png";